<template>
  <div class="d-flex flex-row h-100">
    <div class="h-100 col-3">
      <b-card class="d-flex flex-column">
        <template #header>
          <i class="fas fa-dollar-sign"></i>
          <strong>{{ $lang.Menu.Items.PCI.PDRDebitsReport }}</strong>
        </template>
        <b-form-group :label="$lang.PCI.Team.LabelEmployee" class="my-3">
          <v-select :options="objList" :getOptionLabel="param => `(${param.codigo}) ${param.nome}`" v-model="selectedEmployee" :reduce="param => param.id" @input="() => {pdf = null}"></v-select>
        </b-form-group>
        <b-button variant="third" class="m-3" @click="onSearch">{{ $lang.Common.Buttons.Search }}</b-button>
      </b-card>
    </div>
    <div class="h-100 col-9">
      <object v-if="pdf"
        width="100%"
        height="100%"
        type="application/pdf"
        :data="pdf">
      </object>
    </div>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools'
import EmployeeRepository from '@/shared/http/repositories/business/employee'
import CompanyMixin from '@/store/module/company/mixin'
import PDRDebitsRepository from '@/shared/http/repositories/pci/pdrdebits'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'DebitsReport',
  mixins: [CompanyMixin],
  data () {
    return {
      objList: [],
      selectedEmployee: null,
      pdf: null
    }
  },
  mounted () {
    Tools.MinimizedSidebar()
    EmployeeRepository.GetAllPdr(this.company.id)
      .then(response => {
        if (response.data.code > 0) {
          this.objList = response.data.data
        }
      })
  },
  methods: {
    onSearch () {
      if (this.selectedEmployee) {
        loading.push()
        PDRDebitsRepository.Download({params: {funcionarioID: this.selectedEmployee}})
          .then(response => {
            if (response.data.code > 0) {
              const binary = window.atob(response.data.data.replace(/\s/g, ''))
              const len = binary.length
              const buffer = new ArrayBuffer(len)
              const view = new Uint8Array(buffer)
              for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i)
              }
              const blob = new Blob([view], {type: 'application/pdf'})

              this.pdf = URL.createObjectURL(blob)
            } else throw new Error(response.data.message)
          })
          .catch(err => {
            console.log(err)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => loading.close())
      }
    }
  }
}
</script>

<style scoped>
.card-body {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reports/debitsreport/debitsreport.vue